import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

function StudyMaterialIllustration(props: SvgProps) {
  return (
    <Svg width={164} height={106} viewBox="0 0 164 106" fill="none" {...props}>
      <Path
        d="M14.027 81.448c1.816.316 6.63.758 11.365 0 5.92-.947 18.231-4.025 25.334 0 7.103 4.025 14.917 9.47 17.521 17.284M58.303 60.85c-1.5-1.816-6.345-5.493-13.732-5.683-9.234-.236-15.154.71-20.6 1.184-4.356.379-6.392.158-6.866 0M58.778 68.9c-1.5-1.816-6.346-5.494-13.733-5.683-9.234-.237-15.153.71-20.599 1.184-4.356.379-6.392.158-6.866 0M59.725 76.95c-1.5-1.816-6.345-5.494-13.733-5.683-9.233-.237-15.153.71-20.598 1.184-4.357.379-6.393.158-6.867 0"
        stroke="#1A202C"
        strokeWidth={0.947072}
        strokeLinecap="round"
      />
      <Path
        d="M59.25 97.075c2.368-3.867 10.418-11.601 23.677-11.601h33.858M112.523 61.323l4.973 24.624M57.12 52.8c-2.604-2.605-10.607-7.435-21.782-5.92"
        stroke="#1A202C"
        strokeWidth={0.947072}
        strokeLinecap="round"
      />
      <Path
        d="M4.32 34.568c.947-.474 2.842-2.178 2.842-5.209 1.262.868 4.688 2.557 8.286 2.368 4.499-.237 10.655-1.658 14.206-2.841 3.552-1.184 22.257-4.262 29.36 11.128l5.445 50.668M59.25 40.96c.71-2.21 3.41-6.44 8.524-5.682M80.086 11.602c-5.114 2.273-10.023 8.681-11.838 11.601C69.432 34.568 71.8 57.583 71.8 58.72c0 1.42.473 4.735 2.13 4.025 1.658-.71 2.842-3.315 8.76-7.34 5.92-4.025 12.55-4.262 19.889-4.735 5.872-.38 9.866-3.157 11.129-4.499-1.263-10.813-3.836-33.905-4.026-39.777-.236-7.34-2.13-5.446-3.551-4.262-1.421 1.184-4.499 3.315-9.708 4.735-5.209 1.42-9.944 1.894-16.337 4.736z"
        stroke="#1A202C"
        strokeWidth={0.947072}
        strokeLinecap="round"
      />
      <Path
        d="M73.693 26.281c1.737-2.052 6.062-6.393 9.471-7.34 4.262-1.184 9.234-1.657 14.443-2.367 4.167-.569 7.103-2.447 8.05-3.315M73.813 34.983c1.774-2.02 6.178-6.28 9.604-7.164 4.283-1.105 9.263-1.487 14.484-2.102 4.177-.491 7.147-2.315 8.11-3.166M74.286 44.454c1.773-2.02 6.361-6.066 9.588-7.518 4.735-2.131 9.222-1.043 14.443-1.658 4.177-.491 7.204-2.405 8.167-3.256M75.825 52.324c1.773-2.02 6.361-6.066 9.588-7.518 5.565-2.504 9.222-1.043 14.443-1.658 4.177-.491 7.204-2.405 8.167-3.256"
        stroke="#1A202C"
        strokeWidth={0.947072}
        strokeLinecap="round"
      />
      <Path
        d="M94.293 53.983l1.184 6.63c0 .947.852 2.557 4.262 1.42 4.261-1.42 7.339-2.367 17.52-.947 8.145 1.137 13.97 1.42 15.864 1.42.316 0 .9-.615.71-3.077-.189-2.463-3.551-32.437-5.209-47.117l-.473-5.209c-.079-.947-1.231-2.32-5.209-.237-3.978 2.084-9.392 1.342-11.602.71"
        stroke="#1A202C"
        strokeWidth={0.947072}
        strokeLinecap="round"
      />
      <Path
        d="M120.811 61.797v3.551c-.079.79.521 2.368 3.552 2.368 3.788 0 8.523 1.42 12.785 8.524 3.41 5.682 12.943 7.26 17.284 7.34 1.815.078 5.919-.143 7.814-1.658.315-.158.899-1.231.71-4.262-.19-3.03-1.5-24.15-2.131-34.331l-1.184-13.733c-.237-.315-1.563-.852-4.972-.473-4.262.473-7.577-1.658-10.181-4.736-2.604-3.078-7.577-10.18-14.206-10.417M19.238 45.933V41.67c0-2.841 1.657-4.262 3.314-4.262s3.315.474 5.446 3.078c2.13 2.605.473 6.393-.947 7.813-1.42 1.421-4.025 1.895-6.156 1.895-1.705 0-1.815-2.842-1.657-4.262zM56.173 44.512c-2.526-2.525-10.37-7.15-21.546-5.445M8.346 34.331l4.498 44.512m-1.894 8.998c.632-1.421 1.752-4.736 1.184-6.63"
        stroke="#1A202C"
        strokeWidth={0.947072}
        strokeLinecap="round"
      />
      <Path
        d="M1.006 41.908H5.03l4.972 44.75c2.604.236 8.76.852 11.602 1.42 2.84.568 14.758 4.025 20.362 5.682 3.946 1.263 12.69 4.073 16.1 5.21 3.41 1.136 6.472.946 7.577.71l50.431-11.602v7.34l-46.88 7.34-.473 2.367h-9.234l-1.895-1.894-50.668-6.156-5.92-55.167z"
        fill="#A0A0A0"
        stroke="#A0A0A0"
        strokeWidth={0.947072}
        strokeLinecap="round"
      />
      <Path
        d="M4.084 35.278l5.92 51.379"
        stroke="#1A202C"
        strokeWidth={0.947072}
        strokeLinecap="round"
      />
    </Svg>
  );
}

export default StudyMaterialIllustration;
